module.exports = __webpack_public_path__ + "img/mysql.8057b600.svg";